import { FlowCtx } from 'flows/common/machines/createFlowMachine'
import { assign } from 'xstate'

export const brandPlanStrategyStates = {
  brandPlanStrategy: {
    initial: 'campaignGeneration',
    states: {
      campaignGeneration: {
        initial: 'campaignGeneration',
        states: {
          campaignGeneration: {
            on: {
              MERGE_CTX: {
                actions: assign((ctx: FlowCtx, evt: any) => ({
                  ...ctx,
                  ...evt.payload,
                })),
              },
              BACK: '#fullSignupFlow.brandKitConfirm',
              NEXT: {
                target: 'whereToPublish',
                actions: assign((ctx: FlowCtx, evt: any) => ({
                  ...ctx,
                  ...evt.payload,
                })),
              },
              CHOOSE_STARTER: {
                target: '#fullSignupFlow.contentGallery',
                actions: assign((ctx: FlowCtx, evt: any) => ({
                  ...ctx,
                  ...evt.payload,
                })),
              },
            },
          },
          whereToPublish: {
            on: {
              MERGE_CTX: {
                actions: assign((ctx: FlowCtx, evt: any) => ({
                  ...ctx,
                  ...evt.payload,
                })),
              },
              BACK: 'campaignGeneration',
            },
          },
        },
      },
    },
  },
}
